module.exports = __webpack_public_path__ + "static/img/close.40832ced.svg";